import * as React from "react";
import type { SVGProps } from "react";
const SvgTrace = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M18.27 9.985v4.55a3.734 3.734 0 0 1-3.735 3.734H9.168M10.8 1H4.734A3.734 3.734 0 0 0 1 4.734v5.134"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m5.9 6.834 1.566 1.663c.17.18.17.46 0 .64l-1.565 1.664m3.267 1.4h4.2"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="m17.936 7.452-.114-.747a1.87 1.87 0 0 0-.842-1.291L15.862 4.7M1.467 12.682l.115.747c.081.532.388 1.002.842 1.291l1.118.713"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M15.648 3.317a1.4 1.4 0 1 0-2.768.425 1.4 1.4 0 0 0 2.768-.425Zm-11.894 13.5a1.4 1.4 0 1 0 2.768-.425 1.4 1.4 0 0 0-2.768.425Z"
    />
  </svg>
);
export default SvgTrace;
